/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const QuizSingleQuestionModeHideRunButtonEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('QUIZ_SINGLE_QUESTION_MODE_HIDE_RUN_BUTTON_ENABLED'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class QuizSingleQuestionModeHideRunButtonEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return QuizSingleQuestionModeHideRunButtonEnabledSettingParser.decode(input).map(res => new QuizSingleQuestionModeHideRunButtonEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return QuizSingleQuestionModeHideRunButtonEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return QuizSingleQuestionModeHideRunButtonEnabledSettingParser.encode(data);
    }
    static schema() {
        return QuizSingleQuestionModeHideRunButtonEnabledSettingParser.schema();
    }
}
